import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LineClockIcon from 'LuxKit/Icons/line/LineClockIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const MetadataRow = styled(Group)`
  padding: ${rem(4)} 0;
`

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${props => props.theme.palette.neutral.default.two};
  flex-shrink: 0;
`

interface Props {
  duration?: string
  bookingType: string
  expirationDate?: string
}

function ExperienceDetailMetadata({ duration, bookingType, expirationDate }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={8}>
      {duration && (
        <MetadataRow direction="horizontal" gap={8} verticalAlign="center">
          <IconWrapper><LineClockIcon /></IconWrapper>
          <BodyText variant="medium">{duration}</BodyText>
        </MetadataRow>
      )}
      {expirationDate && (
        <MetadataRow direction="horizontal" gap={8} verticalAlign="center">
          <IconWrapper><LineCalendarIcon /></IconWrapper>
          <BodyText variant="medium">
            {intl.formatMessage(
              {
                id: 'KZM74Y24bIkF0djKYYo1',
                defaultMessage: 'Available until {date}',
                description: 'Label showing the expiration date for experience offer availability in the detail drawer',
              },
              { date: intl.formatDate(new Date(expirationDate), { year: 'numeric', month: 'short', day: 'numeric' }) },
            )}
          </BodyText>
        </MetadataRow>
      )}
      <MetadataRow direction="horizontal" gap={8} verticalAlign="center">
        <IconWrapper><LineTicketIcon /></IconWrapper>
        <BodyText variant="medium">{bookingType}</BodyText>
      </MetadataRow>
    </Group>
  )
}

export default ExperienceDetailMetadata
